// @flow
import React, { Component } from 'react'
import { Router } from 'react-router-dom'
import { connect } from 'react-redux'
import FreshChat from 'react-freshchat'
import { Auth } from './services/auth'
import history from './services/history'
import { updateUser, permissionsUser } from './actions/user'
import LayoutMain from './components/layout-main'
import LayoutLoading from './components/layout-loading'
import LoggedOutHeader from './components/layout-main/loggedOutHeader'
import Notifier from './utils/notification';
import 'antd/dist/antd.min.css';

type State = {
  visible: boolean,
  auth: Auth
}

type Props = {
  isLoggedIn: boolean,
  permissions: Object,
  onUpdateUser: boolean => void,
  onUpdatePermissions: string => void
}

class App extends Component<Props, State> {

  state: State = {
    visible: false,
    auth: new Auth()
  }

  componentDidMount() {
    try {
      if (window.signalR) {
        let connection = new window.signalR.HubConnectionBuilder().withUrl("https://alerts.optionsedu.com/chatHub").build();
    
        connection.on('ReceiveMessage', function (user, message) {
          Notifier.focus(`Have a message from ${user}`, message, '', 'logo.png');
        });
        connection.start().catch(function (err) {
          return console.error(err.toString());
        });
      }
    } catch(err) {
    
    }

  
    this.state.auth.onLoad().then((res: string) => {
    
      const {onUpdateUser, onUpdatePermissions} = this.props
    
      if (res === 'loggedIn' || res === 'authenticated') {
      
        // permissions scope
        const permissions: string = String(localStorage.getItem('permissions'))
        const overrideRole: string = localStorage.getItem('overrideRole')

        if (permissions.includes('tools:beta') && permissions.includes('tools:user')) {
        
          // user is logged in
          onUpdateUser(true)
        
          // set permissions to redux
          onUpdatePermissions(overrideRole || permissions)
        
          // if auth login: redirect to attempted url
          if (res === 'authenticated') {
            const redirect: string = String(localStorage.getItem('redirect'))
            history.replace(redirect)
          }
        
        } else this.showModal()
      }
    })
  }
  
  // --- Logout ---
  handleLogout = () => {

    // reset user redux
    this.props.onUpdateUser(false)
    this.props.onUpdatePermissions('')
  }

  // --- Modal ---
  // show / hide
  showModal = () => this.setState({ visible: true })
  hideModal = () => this.setState({ visible: false })

  onLogin = () => {
    this.state.auth.showLock()
  }

  render() {

    // --- State and Props ---
    const { visible } = this.state
    const { permissions, isLoggedIn } = this.props
    return (
      <Router history={history}>
        <div>
          {   !!permissions.user ?
             (!isLoggedIn || !permissions.user) &&
              <LayoutLoading visible={visible} onHideModal={this.hideModal} /> : null
          }
          { !!permissions.user ?
            <LayoutMain permissions={permissions} onLogout={this.handleLogout} /> :
            (permissions.user || !isLoggedIn) && <LoggedOutHeader onLogin={this.onLogin} />
          }
          <FreshChat
            token='be885fec-2aac-4f93-a97a-6cf49fd539da'
            host='https://wchat.freshchat.com'
            onInit={widget => {
              widget.user.setProperties({
                email: !!isLoggedIn ? localStorage.getItem('user_name') : '',
                first_name: !!isLoggedIn ? localStorage.getItem('user_nickname') : '',
                "plan": "Estate",
                "status": "Active"
              })
              document.getElementById('fc_frame').style.display = !isLoggedIn && 'block'
            }}
          />
        </div>

      </Router>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  isLoggedIn: state.user.isLoggedIn,
  permissions: state.user.permissions
})

const mapDispatchToProps = (dispatch: Function) => ({
  onUpdateUser(loggedIn: boolean) {
    dispatch(updateUser(loggedIn))
  },
  onUpdatePermissions(scope: string) {
    dispatch(permissionsUser(scope))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/App.js